import React from 'react';

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(({ className = '', ...props }, ref) => {
  return (
    <input
      ref={ref}
      className={`flex w-full rounded-md border bg-white dark:bg-[#1e2130] dark:border-[#2a2e3a] dark:text-gray-100 dark:placeholder:text-gray-500 px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-0 dark:focus:ring-offset-[#1a1d27] disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
      {...props}
    />
  );
});

Input.displayName = 'Input';


